import { PostNoTradesSessionInput } from "../../types/api/noTrades";
import { request } from "../apiService";

export const postNoTradesSession = async (userId: string, input: PostNoTradesSessionInput) => {
    return await request<void, PostNoTradesSessionInput>(
        `/v3/tradingsessions/notrades?userId=${userId}`,
        {
            method: "POST",
            input,
        }
    );
};

export const putNoTradesSession = async (
    userId: string,
    sessionId: string,
    input: PostNoTradesSessionInput
) => {
    return await request<void, PostNoTradesSessionInput>(
        `/v3/tradingsessions/notrades/${sessionId}?userId=${userId}`,
        {
            method: "PUT",
            input,
        }
    );
};

export const deleteNoTradesSession = async (id: string) => {
    return await request<void>(`/v3/tradingsessions/notrades/${id}`, {
        method: "DELETE",
    });
}
